import { MedFormAerosolSprayIcon } from "./variants/MedFormAerosolSprayIcon.js";
import { MedFormCapsuleIcon } from "./variants/MedFormCapsuleIcon.js";
import { MedFormCreamIcon } from "./variants/MedFormCreamIcon.js";
import { MedFormEnemaIcon } from "./variants/MedFormEnemaIcon.js";
import { MedFormGeneralIcon } from "./variants/MedFormGeneralIcon.js";
import { MedFormGranulePelletIcon } from "./variants/MedFormGranulePelletIcon.js";
import { MedFormInhalerIcon } from "./variants/MedFormInhalerIcon.js";
import { MedFormInjectionIcon } from "./variants/MedFormInjectionIcon.js";
import { MedFormPatchIcon } from "./variants/MedFormPatchIcon.js";
import { MedFormPillIcon } from "./variants/MedFormPillIcon.js";
import { MedFormSolutionIcon } from "./variants/MedFormSolutionIcon.js";
import { MedFormSuppositoryIcon } from "./variants/MedFormSuppositoryIcon.js";
import { jsx } from "react/jsx-runtime";

//#region src/components/med-form-icon/MedFormIcon.tsx
const MedFormIcon = (props) => {
	switch (props.form?.toLowerCase()) {
		case "aerosol":
		case "aerosol-spray":
		case "aero pow br act": return /* @__PURE__ */ jsx(MedFormAerosolSprayIcon, {});
		case "capsule": return /* @__PURE__ */ jsx(MedFormCapsuleIcon, {});
		case "cream": return /* @__PURE__ */ jsx(MedFormCreamIcon, {});
		case "enema": return /* @__PURE__ */ jsx(MedFormEnemaIcon, {});
		case "granule":
		case "granule-pellet": return /* @__PURE__ */ jsx(MedFormGranulePelletIcon, {});
		case "inhaler": return /* @__PURE__ */ jsx(MedFormInhalerIcon, {});
		case "injection":
		case "soln auto-inj": return /* @__PURE__ */ jsx(MedFormInjectionIcon, {});
		case "patch": return /* @__PURE__ */ jsx(MedFormPatchIcon, {});
		case "pill":
		case "tablet": return /* @__PURE__ */ jsx(MedFormPillIcon, {});
		case "solution": return /* @__PURE__ */ jsx(MedFormSolutionIcon, {});
		case "suppository": return /* @__PURE__ */ jsx(MedFormSuppositoryIcon, {});
		case "general":
		default: return /* @__PURE__ */ jsx(MedFormGeneralIcon, {});
	}
};

//#endregion
export { MedFormIcon };